import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Paper,
  Box,
  Checkbox,
  IconButton,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
  Tooltip,
  TextField,
  Button,
  Dailog,
  FormControl,
  Autocomplete,
  DialogActions,
  Grid,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Cookie from "js-cookie";
import { useMaterialUIController } from "context";
import {
  StyledTypography,
  StyledAgGridContainer,
  StyledSnackbar,
  StyledAlert,
  DeleteButton,
  inputStyle,
} from "components/StyledComponents/styledComponents.js";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import URLs from "constants/urls";
import { StyledButton } from "components/StyledComponents/styledComponents";
import { ViewButton } from "components/StyledComponents/styledComponents";
import { CustomPaper } from "components/Styles/globalStyles";
import { Height } from "@mui/icons-material";

export default function DSAInvoicePayment() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [invoiceData, setInvoiceData] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const jwt_token = Cookie.get("jwt_token");
  const MInput = inputStyle();
  const [selectedBank, setSelectedBank] = useState({
    actledId: 0,
    actledName: "",
  });
  const [dsaDialogOpen, setDsaDialogOpen] = useState(false);
  const [dsaDialogAction, setDsaDialogAction] = useState(null);
  const [dsaDialogMessage, setDsaDialogMessage] = useState("");
  const [receiptDate, setReceiptDate] = useState(new Date().toISOString().split("T")[0]);

  const handleOpenDsaDialog = (action, message) => {
    if (!selectedBank.actledId) {
      setAlert("Please select a bank account to submit payment.", "error");
      return;
    }
    setDsaDialogAction(() => action);
    setDsaDialogMessage(message);
    setDsaDialogOpen(true);
  };

  const handleCloseDsaDialog = () => {
    setDsaDialogOpen(false);
    setDsaDialogAction(null);
    setDsaDialogMessage("");
  };

  const handleConfirmDsaDialog = () => {
    if (dsaDialogAction) {
      dsaDialogAction();
    }
    handleCloseDsaDialog();
  };
  useEffect(() => {
    fetchInvoiceData();
    fetchBankAccountsData();
  }, []);
  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleDateChange = (event) => {
    setReceiptDate(event.target.value); // Will be in YYYY-MM-DD format
  };
  const fetchInvoiceData = async () => {
    try {
      const response = await fetch(`${URLs.headOfficeUnPaidInvoices}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setInvoiceData(data);
    } catch (error) {
      setAlert("Error fetching invoice data", "error");
    }
  };

  const fetchBankAccountsData = async () => {
    setLoading(true);
    const url = `${URLs.headOfficeBanksAcc}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setBankAccounts(data);
    } catch (error) {
      setAlert("Failed to fetch bank accounts", "error");
    }
    setLoading(false);
  };
  const handleCheckboxClick = (invoiceNumber) => {
    if (invoiceNumber) {
      setSelectedInvoices((prev) =>
        prev.includes(invoiceNumber)
          ? prev.filter((id) => id !== invoiceNumber)
          : [...prev, invoiceNumber]
      );
    }
  };

  const handleSelectAll = () => {
    const validInvoices = invoiceData
      .map((row) => row.invoiceNumber)
      .filter((invoice) => invoice !== null && invoice !== undefined);

    setSelectedInvoices(selectedInvoices.length === validInvoices.length ? [] : validInvoices);
  };

  const handlePrintInvoice = useCallback(async (invoiceNo) => {
    try {
      if (!invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(`${URLs.headOfficeInvoiceView}/${invoiceNo}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open in a new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  }, []);

  const handleConfirmPayment = async (data) => {
    if (!selectedBank.actledId) {
      setAlert("Please select a bank account to submit payment.", "error");
      return;
    }
    if (!receiptDate) {
      setAlert("Please Select Amount Reciept Date", "error");
    }
    const url = `${URLs.headOfficeConfirmDsaInvoicePay}`;
    const bodyData = {
      tranDate: receiptDate,
      invoiceNo: data.invoiceNo,
      khBankId: selectedBank.actledId,
      amount: data.netDsaAmount,
      tdsAmount: data.tdsAmount,
      amountPaid: data.netDsaAmount + data.tdsAmount || 0,
    };
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(bodyData),
      });

      const responseText = await response.text();
      if (response.ok) {
        setAlert(`${data.invoiceNo}: ${responseText}`);
        fetchInvoiceData(); // Refresh data
      } else {
        setAlert(`Failed to submit payment: ${responseText}`, "error");
      }
    } catch (error) {
      setAlert("An error occurred while submitting payment.", "error");
    }
  };
  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);
  };

  const columnDefs = [
    {
      headerName: "Actions",
      field: "actions",
      width: 100,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="View Invoice" arrow>
            <IconButton onClick={() => handlePrintInvoice(params.data.invoiceNo)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sorted: true,
      minWidth: 90,
      valueFormatter: (params) => {
        const date = new Date(params.value); // Convert the timestamp to a Date object
        const day = date.getDate().toString().padStart(2, "0"); // Get day with leading zero
        const month = date.toLocaleString("default", { month: "short" }); // Get month as short name
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Return in "dd-MMM-yyyy" format
      },
      sort: "desc",
    },
    { headerName: "Invoice Number", field: "invoiceNo", sortable: true, filter: true, flex: 1 },
    {
      headerName: "Amount",
      field: "amount",
      sortable: true,
      filter: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" }, // Aligns the text to the right
      valueFormatter: (params) =>
        `₹ ${params.value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    { headerName: "DSA Code", field: "dsaCode", sortable: true, filter: true, flex: 1 },
    { headerName: "DSA Name", field: "dsaName", sortable: true, filter: true, flex: 1 },
    {
      headerName: "TDS",
      field: "tdsAmount",
      sortable: true,
      filter: true,
      flex: 1,
      valueSetter: (params) => {
        const value = parseFloat(params.newValue);
        if (isNaN(value) || value < 0) {
          return false; // Invalid input, do not update
        }
        params.data.tdsAmount = value.toFixed(2); // Update the correct field
        return true; // Ensure the grid updates
      },
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 2,
        }).format(params.data.tdsAmount ?? 0); // Ensure correct display
      },
    },
    {
      headerName: "Amount Paid",
      field: "netDsaAmount", // Ensure consistency
      flex: 1,
      valueSetter: (params) => {
        const value = parseFloat(params.newValue);
        if (isNaN(value) || value < 0) {
          return false; // Invalid input, do not update
        }
        params.data.netDsaAmount = value.toFixed(2); // Update the correct field
        return true; // Ensure the grid updates
      },
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 2,
        }).format(params.data.netDsaAmount ?? 0); // Ensure correct display
      },
    },
    {
      headerName: " ",
      field: "submit",
      width: "100px",
      cellRenderer: (params) => (
        <ViewButton
          variant="contained"
          color="primary"
          size="small"
          onClick={() =>
            handleOpenDsaDialog(
              () => handleConfirmPayment(params.data),
              "Are you sure you want to Payment?"
            )
          }
        >
          Submit
        </ViewButton>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "flex-start",
            mr: 1,
          }}
        >
          <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
            <Autocomplete
              options={bankAccounts}
              getOptionLabel={(option) => `${option.actledName}`}
              value={selectedBank}
              onChange={handleBankChange}
              PaperComponent={CustomPaper}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Bank"
                  sx={{
                    height: 43,
                    ...MInput.b,
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: 43,
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                      "&.Mui-focused": {
                        color: "red",
                      },
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <StyledAgGridContainer component={Paper} className="ag-theme-alpine">
            <AgGridReact
              rowData={invoiceData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
            />
          </StyledAgGridContainer>
        </Box>
      </Box>
      <Dialog open={dsaDialogOpen} onClose={handleCloseDsaDialog}>
        <DialogContent sx={{ mt: 1, ...subDialogContentStyle }}>
          {dsaDialogMessage || "Are you sure you want to proceed with this action?"}
          <Grid container spacing={2} sx={{ mt: 0 }}>
            {/* Receipt Date */}
            <Grid item xs={12} sm={12}>
              <TextField
                label="Select Date"
                type="date"
                value={receiptDate} // Controlled input
                onChange={handleDateChange} // Updates state
                fullWidth
                sx={{ ...MInput.b }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: MInput.a },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleCloseDsaDialog} color="secondary">
            Cancel
          </StyledButton>
          <StyledButton onClick={handleConfirmDsaDialog} color="primary">
            Confirm
          </StyledButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
